import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import {
  prefixCurriculumName,
  setSubChildId,
} from "Administrator/modules/AdministratorModule";
import { MAP_EVALUATION_CRITERIA } from "Constants/stringConstants";
export default store => ({
  path: "map-evaluation-criteria",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import("./components"),
        import("../../../AssessmentCriteria/modules/AssessmentCriteriaModule"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "assessmentCriteria",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    const state = store.getState();
    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id"
    );
    const childId = store.dispatch(
      prefixCurriculumName({
        childId: MAP_EVALUATION_CRITERIA,
        curriculumProgramId,
      })
    );
    store.dispatch(setSubChildId(childId));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
